import React from 'react';
import { useNavigate } from 'react-router-dom';

interface CTASectionProps {
    highlightColor: {
        primary: string;
        hover: string;
        gradient: {
            from: string;
            to: string;
            fromLight: string;
            toGray: string;
        };
    };
}

const CTASection: React.FC<CTASectionProps> = ({ highlightColor }) => {
    const navigate = useNavigate();
    return (
        <section className="pt-12 pb-36 px-4 sm:px-6 lg:px-8 bg-black relative notebook-grid overflow-hidden">
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white/10 to-transparent pointer-events-none"></div>
            <div className="max-w-7xl mx-auto relative z-10">
                <div className="bg-neutral-900 p-10 text-center observe-fade opacity-0 grid-accent">
                    <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
                        Give your team the competitive edge.
                    </h3>
                    <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
                        Join teams across all levels who trust CGM Sports to optimize performance, prevent injuries, and make data-driven coaching decisions. 
                        Connect your wearable devices today and start receiving AI-powered insights immediately.
                    </p>
                    <button
                        onClick={() => navigate('/register')}
                        className="px-8 py-4 text-sm font-semibold transition-all duration-200 ease-out hover:scale-105 cursor-pointer"
                        style={{
                            backgroundColor: 'transparent',
                            color: 'white',
                            border: '1px solid white',
                            borderRadius: '0',
                            boxShadow: 'none'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'white';
                            e.currentTarget.style.color = 'black';
                            e.currentTarget.style.boxShadow = '0 2px 10px -1px rgba(0, 0, 0, 0.1), 0 2px 8px -1px rgba(0, 0, 0, 0.06)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = 'white';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                        Get Started
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CTASection;

